jQuery(document).ready(function($){
    $('a[href*="#"]').on('click', function(e){
        var href = $(this).attr('href');
        var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#')) : '';

        if (!hash || hash === '#') return;

        var url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;

        var element = $(hash);

        if (element.length > 0) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: element.offset().top - 100
            }, 800);
        }
    });

    if (window.location.hash) {
        var target = $(window.location.hash);
        if (target.length > 0) {
            $('html, body').scrollTop(0);
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 800);
        }
    }

    $('.back-to-top').on('click', function(e){
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 800);
    });
});